import { render, staticRenderFns } from "./Spacer.vue?vue&type=template&id=7e330fc4"
import script from "./Spacer.vue?vue&type=script&lang=js"
export * from "./Spacer.vue?vue&type=script&lang=js"
import style0 from "./Spacer.vue?vue&type=style&index=0&id=7e330fc4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports